// extracted by mini-css-extract-plugin
export var body = "xNf3igV_J640K66xjeDk";
export var fontBold = "KogZ1r6uXgWgcTxuKApF";
export var fontMedium = "VvxDoIviAsp3tO4DWD_w";
export var fontRegular = "hRw0qtA2ax9yL1WrEN3E";
export var large = "BWKfRbeI9CRcX6fxF6JA";
export var micro = "HZCQsPxKxRwWwD7lnu9B";
export var mini = "EgrQMIpHwxf8fXQCbZhM";
export var root = "zzmkm5kyAXQT52QMwM57";
export var small = "T9SlfTP6wuNna7tk3nQ5";